import React from "react";
import Menu from "../components/Menu";
import Contenido from "../views/Contenido";
import { getMenu } from "../requests/req_auth";
import { amb, notifica } from "../requests/utils";

export default class Admin extends React.Component {
  constructor(props) {
    super(props);
    this.state = { opcion: "Inicio", menu: null };
    this.menu = this.menu.bind(this);
    this.childHandler = this.childHandler.bind(this);
  }

  componentDidMount() {
    getMenu((x) => this.menu(x));
  }

  menu(datos) {
    if (datos) {
      if (datos.code === 1) {
        notifica("warning", datos.message, "Error!");
        sessionStorage.removeItem(amb + "UD");
        window.location = "/auth/login";
      } else {
        this.setState({ menu: datos.data });
      }
    } else {
      sessionStorage.removeItem(amb + "UD");
      window.location = "/auth/login";
    }
  }

  childHandler(dataFromChild) {
    this.setState({ opcion: dataFromChild });
  }

  render() {
    return (
      <div className="dv_main">
        <Menu action={this.childHandler} datos={this.state.menu} />
        <Contenido cont={this.state.opcion} datos={this.state.menu} />
      </div>
    );
  }
}
